import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedToppagesjoinus,
  addingToppagesjoinus,
  addingToppagesjoinusFailed,
  editedToppagesjoinus,
  editingToppagesjoinus,
  editingToppagesjoinusFailed,
  foundToppagesjoinus,
  loadedToppagesjoinus,
  loadingToppagesjoinus,
  loadingToppagesjoinusFailed,
  removedToppagejoinus,
  removingToppagejoinus,
  removingToppagejoinusFailed,
  searchingToppagesjoinus,
  searchingToppagesjoinusFailed,
  softRemovedToppagesjoinus,
  softRemovingToppagesjoinus,
  softRemovingToppagesjoinusFailed,
  ToppagesjoinusAction,
  ToppagesjoinusActionTypes,
} from '../actions/toppagesjoinusActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.SEARCH_TOPPAGESJOINUS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/toppagesjoinus/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundToppagesjoinus(response.data, action.keep)),
        startWith(searchingToppagesjoinus()),
        catchError(() => of(searchingToppagesjoinusFailed()))
      )
    })
  )

const loadToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.LOAD_TOPPAGESJOINUS)),
    switchMap((action) => {
      let url = `${API_URL}/api/toppagesjoinus/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedToppagesjoinus(response.data)),
        startWith(loadingToppagesjoinus()),
        catchError(() => of(loadingToppagesjoinusFailed()))
      )
    })
  )
}

const addToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.ADD_TOPPAGESJOINUS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/toppagesjoinus/`, data, config)).pipe(
        map((response) => addedToppagesjoinus(response.data)),
        startWith(addingToppagesjoinus()),
        catchError((err) => of(addingToppagesjoinusFailed(err.response)))
      )
    })
  )

const removeToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.REMOVE_TOPPAGEJOINUS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagesjoinus/${action.payload._id}`)).pipe(
        map((response) => removedToppagejoinus()),
        startWith(removingToppagejoinus()),
        catchError(() => of(removingToppagejoinusFailed()))
      )
    )
  )

const softRemoveToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.SOFT_REMOVE_TOPPAGESJOINUS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagesjoinus/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedToppagesjoinus(response.data.record)),
        startWith(softRemovingToppagesjoinus()),
        catchError((err) => of(softRemovingToppagesjoinusFailed(err.response)))
      )
    )
  )

const editToppagesjoinusEpic: Epic<ToppagesjoinusAction, ToppagesjoinusAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagesjoinusActionTypes.EDIT_TOPPAGESJOINUS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/toppagesjoinus/${action.payload._id}`, data, config)).pipe(
        map((response) => editedToppagesjoinus(response.data)),
        startWith(editingToppagesjoinus()),
        catchError((err) => of(editingToppagesjoinusFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchToppagesjoinusEpic,
  loadToppagesjoinusEpic,
  addToppagesjoinusEpic,
  removeToppagesjoinusEpic,
  softRemoveToppagesjoinusEpic,
  editToppagesjoinusEpic
)
